export enum CandidateCustomFieldType {
  String = 'string',
  Select = 'select',
  Date = 'date',
  Multiselect = 'multiselect',
  Number = 'number',
  Base = 'base',
  Custom = 'custom',
}
